import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { fmtN, fmtRelative } from '@/lib/utils';
import { PageHeader } from '@/components/PageHeader';
import { Pagination } from '@/components/Pagination';

type Row = {
  id: string;
  userId: string;
  title: string | null;
  createdAt: string;
  userEmail: string | null;
};
type Env = { rows: Row[]; page: number; pageSize: number; total: number };

export function AiConversations() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery<Env>({
    queryKey: ['/admin/api/ai/conversations', page],
    queryFn: () => api.get<Env>(`/admin/api/ai/conversations?page=${page}&pageSize=50`),
  });

  return (
    <div>
      <PageHeader
        title="AI Conversations"
        subtitle={data ? `${fmtN(data.total)} total` : 'Loading…'}
      />

      <div className="ad-card overflow-hidden">
        <table className="ad-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Title</th>
              <th>Started</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={4} className="text-center text-text3 py-10">
                  Loading…
                </td>
              </tr>
            ) : (
              data?.rows.map((c) => (
                <tr key={c.id}>
                  <td className="font-mono text-xs">{c.userEmail}</td>
                  <td>{c.title ?? <span className="text-text3 italic">Untitled</span>}</td>
                  <td className="text-text2">{fmtRelative(c.createdAt)}</td>
                  <td className="text-right">
                    <Link to={`/ai/${c.id}`} className="text-accent hover:underline text-xs">
                      View
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {data && <Pagination page={data.page} pageSize={data.pageSize} total={data.total} onPage={setPage} />}
    </div>
  );
}
